export const config = {
  authBaseUrl: process.env.REACT_APP_AUTH_BASE_URL || 'http://localhost:3000',
  apiUrl: process.env.REACT_APP_API_URL || 'http://localhost:5000/api'
};